// "use client";

import Link from "next/link";

const SITEMAP = [
  {
    title: "Contact Us",
    menu: ["+92(21) 32428196-98", "Suite # 101-102, Roshan Trade Center (TAI),", "Near Naheed Super Market ", "Shaheed-e-Millat Road Karachi, Pakistan.", "info@nubitsoft.com"],
  },
  {
    title: "Trending Tech",
    menu: ["Full Stack Development", "Machine Learning & AI", "NFT MarketPlace", "Cyber Security", "Augmented Reality"],
  },
  {
    title: "Industries",
    menu: ["Financial Services", "Education", "Healthcare", "Public Sector", "B P O "],
  },
  {
    title: "Quick Link",
    links: ["About", "PrivacyPolicy", "Contact ", "Facebook", "LinkedIn", "YouTube"],
  },
];
// console.count("footer")
export function Footer() {
  return (
   <footer className="w-full bg-black text-white">
  {/* Container ko center karne ke liye mx-auto aur full width ke liye max-w-screen-xl use karein */}
  <div className="mx-auto max-w-7xl  px-6 sm:px-8">
    
    {/* Grid setup: mobile par 1 column, tablet par 2, desktop par 4 */}
    <div className="grid grid-cols-1 gap-10 py-12 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 justify-items-center md:justify-items-start">
      
      {SITEMAP.map(({ title, links, menu }, index) => (
        <div key={index} className="w-full max-w-[300px] md:max-w-none text-left">
          <h3 className="mb-6 font-bold uppercase opacity-60 text-sm tracking-widest">
            {title}
          </h3>
          
          <ul className="space-y-3">
            {links?.map((link, i) => (
              <li key={i}>
                <Link
                  href={
                    link === "linkedIn" ? 'https://www.linkedin.com/company/nubit-software-pvt-ltd/' : 
                    link === "Facebook" ? 'https://www.facebook.com/Nubitsoftware' : 
                    link === "YouTube" ? 'https://www.youtube.com/@nubitsoft' : 
                    `/${link.toLowerCase()}`
                  }
                  className="inline-block transition-all hover:translate-x-1 hover:text-gray-200"
                >
                  {link}
                </Link>
              </li>
            ))}
            
            {menu?.map((item, i) => (
              <li key={i}>
                <span className="inline-block opacity-90">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>

  </div>
</footer>
  );
}
